import { combineReducers } from '@reduxjs/toolkit';

import { helpChatSlice } from './helpChatSlice';

export const HELP_CHAT_REDUCER_KEY = helpChatSlice.name;
export const helpChatReducer = combineReducers({
  [helpChatSlice.name]: helpChatSlice.reducer,
});
